<template>
   <div class="page-user-lsit">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">好物兌換商品</div>
         <div class="breadcrumb-item">好物兌換商品列表</div>
      </div>

      <div class="card-block">
         <div class="breadcrumb-item">篩選搜索</div>
         <br>
         <Form inline class="pg-form-inline form-input-wrap">

            <FormItem>
               <label class="input-label"
                      style="line-height: 19px;font-weight: 500;width: 64px;height: 22px;">商品名稱</label>
               <Input style="width: 200px;height: 40px;margin-right: 50px;border-radius: 6px;" v-model="form.order_name"
                      @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem>

            <FormItem>
               <div class="pg-btn-wrap">
                  <div class="pg-btn style1"
                       style="line-height: 30px;font-size: 16px;width: 100px;height: 30px;border-radius: 6px;"
                       @click="handleSearch">查詢搜索
                  </div>

                  <div class="pg-btn"
                       style="line-height: 30px;font-size: 16px;width: 100px;height: 30px;border-radius: 6px;color: #FF466B"
                       @click="handleReset">重置
                  </div>
               </div>
            </FormItem>
         </Form>
      </div>

      <div class="card-block pd-bt">
         <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="上架" :name="String(1)"></el-tab-pane>
            <el-tab-pane label="下架" :name="String(0)"></el-tab-pane>
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
               <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
               <div class="loading-text">Loading</div>
            </Spin>

            <Table size="small"
                   no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">
               <template slot-scope="{ row, index }" slot="orderimages">
                  <div class="demo-image__preview" @click="handlesrcList(row.orderimages)">
                     <el-image
                        style="width: 50px; height: 50px"
                        :src="row.orderimages[0].image_path"
                        :preview-src-list="srcList">
                     </el-image>
                  </div>
               </template>

               <template slot-scope="{ row, index }" slot="price">
                  <div class="pg-btn-wrap">
                     <div>總金額: {{ row.price }}</div>
                     <div>積分: {{ row.integral_price }}</div>
                     <div>集金幣: {{ row.jpoint_price }}</div>
                  </div>
               </template>

               <template slot-scope="{ row, index }" slot="order_label_status">
                  <div v-if="row.orderlabel.length == 0">
                     - - -
                  </div>
                  <div v-else-if="row.orderlabel.length > 0">
                     {{ row.orderlabel[0].name }}
                     <Switchs true-color="#51f4a9" v-model="row.order_label_status" @on-change="statusChange(row)"/>
                  </div>

               </template>

               <template slot-scope="{ row, index }" slot="action">
                  <div class="pg-btn-wrap">
                     <div class="pg-btn style2"
                          style="line-height: 30px;font-size: 16px;width: 70px;height: 30px;border-radius: 6px;"
                          @click="handleEdit(row)">修改
                     </div>
                     <!--<div class="pg-btn style1"
                          style="line-height: 30px;font-size: 16px;width: 70px;height: 30px;border-radius: 6px;"
                          @click="handleDesc(row)">備注
                     </div>-->
                  </div>
               </template>
            </Table>

            <div class="pg-pagger">
               <Row>
                  <Col span="12" class="pagger-left">
                     <div class="pagger-total">總共{{ totalCount }}條記錄</div>
                  </Col>
                  <Col span="12" class="pagger-right">
                     <div>
                        <div class="pagger-sizer">
                           <span>每頁</span>
                           <Select v-model="curPageSize" size="small" placeholder="數量"
                                   @on-change="handlePageSizeChange">
                              <Option :value="10">10</Option>
                              <Option :value="20">20</Option>
                              <Option :value="30">30</Option>
                              <Option :value="40">40</Option>
                              <Option :value="50">50</Option>
                           </Select>
                        </div>

                        <div class="pagger-elevator">
                           <span>跳轉</span>
                           <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                  @on-enter="handlePageEnter"/>
                        </div>

                        <Page size="small"
                              :current="pageIndex"
                              :page-size="curPageSize"
                              :total="totalCount"
                              @on-change="handlePageChange">
                        </Page>
                     </div>
                  </Col>
               </Row>
            </div>
         </el-tabs>
      </div>
      <Modal v-model="showModal"
             title="備注"
             width="300"
             autofocus
             @on-ok="handleDescModal"
             @on-cancel="handleDescCancel">

         <Input type="textarea"
                style="margin-bottom: 18px;"
                :autosize="{minRows: 4}" v-model="desc"/>
      </Modal>
   </div>
</template>

<script>
import allgoodrecycle from "../../customerservices/allgoodrecycle/allgoodrecycle";

export default {
   data() {
      return {
         srcList: [],
         activeName: "1",
         pageIndex: 1,   //页码
         curPageSize: 10,    //一页数量
         pageInput: '',  //输入的页码
         isSubmiting: false,
         totalCount: 0,
         status: false, // 是否開啓
         showModal: false,
         desc: '',
         rowId: '',
         form: {
            id: '',
            order_id: '',
            order_name: '',
            order_titile: '',
            product_desciption: '',
            order_shelf: '',
            order_release_time: '',
            order_close_time: '',
            order_label_status: '',
            start_time: '',
            end_time: '',
         },
         table: {
            column: [
               {
                  title: '操作',
                  slot: 'action',
                  align: 'center',
                  minWidth: 150
               },
               {
                  title: 'APP排序',
                  key: 'order_srot_app',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '商品主圖',
                  align: 'center',
                  slot: 'orderimages',
                  sortable: true,
                  minWidth: 150
               },
               {
                  title: '商品名稱',
                  key: 'order_name',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '價格',
                  key: 'price',
                  slot: 'price',
                  align: 'center',
                  width: 130
               },
               {
                  title: '標簽',
                  slot: 'order_label_status',
                  align: 'center',
                  minWidth: 150
               }, {
                  title: '商品類型',
                  key: 'ordertype',
                  align: 'center',
                  minWidth: 150
               },
               {
                  title: '庫存',
                  key: 'order_inventory',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '銷量',
                  key: 'order_purchased_quantity',
                  align: 'center',
                  minWidth: 80
               },
               {
                  title: '總庫存',
                  key: 'order_total',
                  align: 'center',
                  minWidth: 80
               },

            ],
            data: []
         }
      };
   },
   mounted() {
      this.getList(this.activeName, 1, 10);
   },
   activated() {
      this.getList(this.activeName);
   },
   methods: {
      handleDescCancel() {
         this.desc = ''
         this.rowId = ''
      },
      handleDescModal() {
         this.$Rq.requestAuth({
            url: this.$Api.commodityDesc,
            method: 'post',
            data: {
               remark: this.desc,
               order_number: this.rowId
            }
         }).then(res => {
            console.log(res)
         })
      },
      handleDesc(row) {
         row.id && (this.rowId = row.id)
         this.showModal = true
      },
      handleReset() {
         this.form.order_name = '';
      },
      handlesrcList(imgobj) {

         this.srcList = [];
         for (let i = 0; i < imgobj.length; i++) {
            if (imgobj[i].type == '1') {
               this.srcList.push(imgobj[i].image_path);
            }
         }
      },
      statusChange(item) {
         let id = item.id;
         let status;
         if (item.order_label_status == true) {
            status = "1";
         } else {
            status = "0";
         }
         this.isSubmiting = true;

         this.$Rq.requestAuth({
            url: this.$Api.commodityEdit,
            method: 'post',
            data: {
               order_id: id,
               order_label_status: status
            }
         }).then((res) => {
            this.isSubmiting = false;
            if (res.code == 0) {
               this.$Utils.showSuccess(res.msg);
               this.getList(this.activeName);
            } else {
               this.$Utils.showTipInfo(res.msg);
            }
         }).catch((err) => {
            this.isSubmiting = false;
         });
      },
      handleClick(tab, event) {
         this.getList(tab.name, 1, 10);
      },
      getList(status_active, offset, limit) {
         let order_shelf_status;
         if (limit != undefined) {
            this.curPageSize = limit;
         }
         if (offset != undefined) {
            this.pageIndex = offset;
         }
         if (status_active == 1) {
            order_shelf_status = 1;
         }
         if (status_active == 0) {
            order_shelf_status = 0;
         }

         let form = this.form;
         this.isSubmiting = true;
         this.$Rq.requestAuth({
            url: this.$Api.commodityList,
            method: 'get',
            data: {
               order_name: form.order_name,
               order_shelf: order_shelf_status,
               offset: (this.pageIndex - 1) * this.curPageSize,
               limit: this.curPageSize,
            }
         }).then((res) => {
            this.isSubmiting = false;
            if (res.code == 0) {
               let tempArr = [];
               let resData = res.data.data;
               for (let i = 0; i < resData.length; i++) {
                  let status;
                  if (resData[i].order_label_status == "1") {
                     status = true;
                  } else if (resData[i].order_label_status == "0") {
                     status = false;
                  }
                  tempArr.push({
                     id: resData[i].id, //订单id
                     order_name: resData[i].order_name, //订单名称
                     order_titile: resData[i].order_titile, //订单副标题
                     product_desciption: resData[i].product_desciption, //订单详情
                     price: resData[i].price, //总价
                     integral_price: resData[i].integral_price, //积分支付时的价格
                     jpoint_price: resData[i].jpoint_price, //Jpoint支付时的价格
                     order_inventory: resData[i].order_inventory, //商品库存
                     order_purchased_quantity: resData[i].order_purchased_quantity == null ? '- - -' : resData[i].order_purchased_quantity, //商品单位
                     order_shelf: resData[i].order_shelf, //是否上架
                     order_srot_app: resData[i].order_srot_app, //商品app排序
                     order_release_time: resData[i].order_release_time, //商品展示开始时间
                     order_close_time: resData[i].order_close_time, //商品展示结束时间
                     order_label_id: resData[i].order_label_id, //标签id
                     order_label_status: status, //标签状态

                     orderlabel: resData[i].orderlabel == null ? '- - -' : resData[i].orderlabel, //标签

                     order_total: resData[i].order_total == null ? '- - -' : resData[i].order_total,

                     orderimages: resData[i].orderimages == '' ? '- - -' : resData[i].orderimages, //标签,
                     orderimages_gid: resData[i].orderimages == null ? '- - -' : resData[i].orderimages.g_id, //标签圖片ID,
                     orderimages_image_path: resData[i].orderimages == null ? '- - -' : resData[i].orderimages.image_path, //标签圖片路徑,
                     orderimages_type: resData[i].orderimages == null ? '- - -' : resData[i].orderimages.type, //标签圖片Type,

                     orderdoc_g_id: resData[i].orderdoc == null ? '- - -' : resData[i].orderdoc.g_id, //商品ID
                     orderdoc_type: resData[i].orderdoc == null ? '- - -' : resData[i].orderdoc.type, //详情类型
                     orderdoc_admin_name: resData[i].orderdoc == null ? '- - -' : resData[i].orderdoc.admin_name, //后台添加/修改人员
                     orderdoc_order_info: resData[i].orderdoc == null ? '- - -' : resData[i].orderdoc.order_info, //html代码
                     order_parameter_app: resData[i].order_parameter_app,
                     order_parameter_pc: resData[i].order_parameter_pc,
                     // ordertype: resData[i].ordertype == null ? '- - -' : resData[i].ordertype?.name, // 商品類型
                  });
               }
               this.totalCount = res.data.count;
               this.table.data = tempArr;
            } else {
               this.totalCount = 0;
               this.table.data = [];
            }
         }).catch((err) => {
            this.isSubmiting = false;
         });
      },
      handleToAdd(item) {
         this.$router.push({path: '/commodityAdd'});
      },
      handleEdit(item) {
         this.$router.push({path: '/commodityEdit?id=' + item.id})
      },
      handleDelete(item) {
         let id = item.id;
         this.$Modal.confirm({
            title: '提示',
            content: '確定刪除嗎？',
            cancelText: '取消',
            okText: '確定',
            onOk: () => {
               let tableData = this.table.data;
               this.isSubmiting = true;
               this.$Rq.requestAuth({
                  url: this.$Api.commodityDelete,
                  method: 'post',
                  data: {
                     g_id: id
                  }
               }).then((res) => {
                  this.isSubmiting = false;
                  if (res.code == 0) {
                     this.$Utils.showSuccess(res.msg);
                     this.getList(this.activeName);
                  } else {
                     this.$Utils.showTipInfo(res.msg);
                  }
               }).catch((err) => {
                  this.isSubmiting = false;
               });
            }
         });
      },
      handleSearch() {
         this.pageIndex = 1;
         // this.activeName = String(1);
         this.getList(this.activeName, 1, 10);
      },
      handlePageSizeChange(value) {
         this.pageIndex = 1;
         this.getList(this.activeName);
      },
      handlePageInput() {
         let value = ('' + this.pageInput).replace(/\D/g, '');
         let pageCount = Math.ceil(this.totalCount / this.curPageSize);
         if (value > pageCount) {
            value = pageCount;
         }
         this.pageInput = value;
      },
      handlePageEnter() {
         if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
         if (this.pageInput == 0) {
            this.pageInput = 1;
         }
         this.pageInput = parseInt(this.pageInput);
         this.pageIndex = this.pageInput;
         this.getList(this.activeName);
      },
      handlePageChange(value) {
         this.pageIndex = value;
         this.getList(this.activeName);
      }
   }
};
</script>

<style lang="scss" scoped>
@import 'commodityList.scss';
</style>
